import * as React from 'react';
import { useDrag } from 'react-dnd';
import { FieldItem, ItemTypes } from '../types';
import { DragTag } from './drag-tag';
import { getEmptyImage } from 'react-dnd-html5-backend';

interface DragPanelComponentProps {
  className: string;
  field: FieldItem;
  onSelect: (field: FieldItem) => void;
  onRemove?: (field: FieldItem) => void;
  isDragging?: any;
  isSelected?: boolean;
  added?: boolean;
}

export const dragPanelForItemType = (itemType: ItemTypes) => {
  const DragPanelComponent: React.FC<DragPanelComponentProps> = ({
    field, className, isSelected, onSelect, onRemove
  }) => {
    
    const [{}, drag, preview] = useDrag(() => ({
      item: { field },
      type: itemType,
      collect: (monitor) => {
        return {
          isDragging: monitor.isDragging()
        };
      }
    }));

    React.useEffect(() => {
      preview(getEmptyImage(), { captureDraggingState: true });
    }, []);
  
    const handleOnClick = () => {
      if (!!onSelect) {
        if (isSelected) {
          onRemove?.(field);
        } else {
          onSelect(field);
        }
      }
    };

    const title = field.allLevelDescription || field.description;

    return <li className={className}>
      <DragTag
        title={title}
        active={isSelected}
        added={field.added}
        onClick={handleOnClick}
        ref={drag}      
      />        
    </li>;
  };
  
  return (DragPanelComponent);
};
